import { classnames } from '@aibees/shared/utils';
import { WhiteLabelLayout } from '@aibees/elephant/layouts';
import { WhiteLabelTab, WhiteLabelTabs } from '@aibees/elephant/types';
import { WhiteLabelGeneralTab } from '@aibees/elephant/feature';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { WhiteLabelProps as Props } from './types';
import { WhiteLabelProvider } from './context';

export const WhiteLabel = memo(({ className }: Props) => {
  const tabPanels: WhiteLabelTab[] = [
    {
      label: WhiteLabelTabs.GENERAL,
      value: WhiteLabelTabs.GENERAL,
      component: <WhiteLabelGeneralTab />,
    },
    {
      value: WhiteLabelTabs.LOGIN_PAGE,
      label: WhiteLabelTabs.LOGIN_PAGE,
      component: <>{WhiteLabelTabs.LOGIN_PAGE}</>,
    },
    {
      value: WhiteLabelTabs.SEARCH_PANEL,
      label: WhiteLabelTabs.SEARCH_PANEL,
      component: <>{WhiteLabelTabs.SEARCH_PANEL}</>,
    },
    {
      value: WhiteLabelTabs.FILTERS,
      label: WhiteLabelTabs.FILTERS,
      component: <>{WhiteLabelTabs.FILTERS}</>,
    },
    {
      value: WhiteLabelTabs.RESULT_TABLE,
      label: WhiteLabelTabs.RESULT_TABLE,
      component: <>{WhiteLabelTabs.RESULT_TABLE}</>,
    },
    {
      value: WhiteLabelTabs.MAIN_PAGE,
      label: WhiteLabelTabs.MAIN_PAGE,
      component: <>{WhiteLabelTabs.MAIN_PAGE}</>,
    },
  ];

  return (
    <WhiteLabelProvider>
      <Styled.Wrapper
        className={classnames('WhiteLabel', className)}
        sx={SX.root}
      >
        <WhiteLabelLayout tabs={tabPanels} />
      </Styled.Wrapper>
    </WhiteLabelProvider>
  );
});

WhiteLabel.displayName = 'WhiteLabel';
